import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {INetDirectoryFileData} from './net-directory-file-slice-type';

export type TNetDirectoryFileArgs = {
    filename: string;
};
export const fetchNetDirectoryFileNameListData = () => (
    performRequest<string[]>({
        url: '/fileupload/getExternal',
        method: ERequestType.GET,
    })
);

export const postDocumentUploadTemplateConfiguration = async (args: TNetDirectoryFileArgs) => {
    const {filename} = args;
    return performRequest<INetDirectoryFileData>({
        url: '/fileupload/postExternal',
        method: ERequestType.POST,
        params: {filename},
        data: filename,
    });
};
